import { render, staticRenderFns } from "./FQA.vue?vue&type=template&id=0df20dac&scoped=true&"
import script from "./FQA.vue?vue&type=script&lang=ts&"
export * from "./FQA.vue?vue&type=script&lang=ts&"
import style0 from "./FQA.vue?vue&type=style&index=0&id=0df20dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df20dac",
  null
  
)

component.options.__file = "FQA.vue"
export default component.exports